module.exports = __webpack_public_path__ + "img/chongci_ps_21.c771fe9f.jpg";